import React from "react";
import { Card } from "@/components/ui/card";

export function StatsLoadChart({ data }) {
  const max = Math.max(1, ...data.students.map((r) => r.total));
  const avgPct = (data.summary.avg / max) * 100;
  return (
    <Card className="p-4 border border-stone-200 shadow-none rounded-xl" data-testid="stats-chart">
      <div className="flex flex-wrap gap-3 mb-4 text-xs">
        {data.mansioni.map((m) => (
          <span key={m.id} className="inline-flex items-center gap-1.5"><span className="w-2.5 h-2.5 rounded-sm" style={{ background: m.color }}/>{m.name} <span className="text-stone-400">{m.count}</span></span>
        ))}
      </div>
      <div className="space-y-1.5">
        {data.students.map((r) => (
          <div key={r.student_id} className="grid grid-cols-[150px_1fr_90px] sm:grid-cols-[220px_1fr_120px] items-center gap-3 text-sm" data-testid={`stats-row-${r.student_id}`}>
            <div className="truncate" title={r.name}>{r.name}<span className="text-[11px] text-stone-400 ml-1">{r.year_level ? `${r.year_level}°` : ""}</span></div>
            <div className="relative h-5 bg-stone-100 rounded">
              <div className="absolute inset-y-0 left-0 flex rounded overflow-hidden" style={{ width: `${(r.total / max) * 100}%` }}>
                {data.mansioni.map((m) => r.by_mansione[m.id] ? (
                  <div key={m.id} style={{ width: `${(r.by_mansione[m.id] / r.total) * 100}%`, background: m.color }} title={`${m.name}: ${r.by_mansione[m.id]}`}/>
                ) : null)}
              </div>
              <div className="absolute inset-y-[-3px] w-px bg-[#E2725B]" style={{ left: `${avgPct}%` }} title={`Media ${data.summary.avg}`}/>
            </div>
            <div className="text-right font-mono text-xs">
              <b>{r.total}</b>
              <span className={`ml-1.5 ${r.delta > 0 ? "text-red-600" : r.delta < 0 ? "text-sky-700" : "text-stone-400"}`}>{r.delta > 0 ? "+" : ""}{r.delta}</span>
            </div>
          </div>
        ))}
      </div>
      <div className="text-[11px] text-stone-500 mt-4">La linea arancione indica la media ({data.summary.avg}). Accanto al totale, lo scostamento dalla media: in rosso chi è sopra, in blu chi è sotto.</div>
    </Card>
  );
}
